import { render, staticRenderFns } from "./FrontendLayoutForm.vue?vue&type=template&id=744bec04&scoped=true&"
import script from "./FrontendLayoutForm.vue?vue&type=script&lang=js&"
export * from "./FrontendLayoutForm.vue?vue&type=script&lang=js&"
import style0 from "./FrontendLayoutForm.vue?vue&type=style&index=0&id=744bec04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744bec04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardTitle,VCol,VForm,VRow})
